<template>
  <video
    ref="video"
    class="vue-video"
  >
    <source
      :src="videoSource"
      type="video/mp4"
    >
  </video>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
export interface Props {
  button?: string
  desktop: string
  mobile?: string
}
const props = defineProps<Props>()
const video = ref()
const videoSource = ref()

const setVideoSource = () => {
  const mq = window.matchMedia('(max-width: 767px)')
  videoSource.value = mq.matches && props.mobile ? props.mobile : props.desktop
}

// const handleResize = () => {
//   const player = video.value
//   player.pause()
//   setVideoSource()
//   player.load()
//   player.play()
// }

onMounted(() => {
  const { value } = video
  const btn = document.createElement('button')
  btn.setAttribute('aria-label', 'play video')
  btn.classList.add('vue-video-play-button')
  btn.style.backgroundImage = `url(${props.button})`
  value.parentNode.appendChild(btn)
  value.addEventListener('suspend', () => btn.style.opacity = '1')
  value.addEventListener('play', () => btn.style.display = 'none')
  btn.addEventListener('click', () => value.play())
  // window.addEventListener('resize', debounce(handleResize, 200, false))
  setVideoSource()
})
</script>
